import { withPluginApi as __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__ } from "discourse/lib/plugin-api";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "discourse/lib/plugin-api"

;// ./src/plugin/assets/javascripts/discourse/initializers/waze-wiki-initializer.ts

/* harmony default export */ const waze_wiki_initializer = ({
    name: "init-waze-wiki",
    initialize() {
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__("2.0.0", (api) => {
            // Glimmer post stream implementation
            api.registerValueTransformer("post-class", ({ value, context: { post }, }) => {
                if (post.wiki && post.post_number === 1) {
                    // Add a class to the post so we can hide the default avatar via CSS
                    return [...(value || []), "waze-wiki-first-post"];
                }
                return value;
            });
            api.registerValueTransformer("post-meta-data-infos", ({ value: metadata, context: { post }, }) => {
                if (post.wiki && post.post_number === 1) {
                    metadata.delete("locked_indicator");
                }
            });
        });
    },
});

export { waze_wiki_initializer as default };
